import { render, staticRenderFns } from "./PendingList.vue?vue&type=template&id=b802981a"
import script from "./PendingList.js?vue&type=script&lang=js&external"
export * from "./PendingList.js?vue&type=script&lang=js&external"
import style0 from "./PendingList.vue?vue&type=style&index=0&id=b802981a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports